// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2W1YV","content":"styles_content__1Ejtc","checkbox":"styles_checkbox__119sb","checkboxLabel":"styles_checkboxLabel__3Jo_T"};